mmf_modules.define('utils/ensure_dataLayer',[], function () {

    'use strict';

    // Ensures the global dataLayer object is defined
    window.dataLayer = window.dataLayer || [];

    return window.dataLayer;

});
